var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "property-title-time-picker" }, [
    !_vm.isReadOnly
      ? _c(
          "div",
          { staticClass: "property-title-time-picker__time-pickers" },
          [
            _c("DatePicker", {
              attrs: {
                date: _vm.startDate,
                "has-timezone": true,
                "timezone-id": _vm.startTimezone,
                prefix: "from",
                "is-all-day": _vm.isAllDay,
                "append-to-body": _vm.appendToBody,
                "user-timezone-id": _vm.userTimezone
              },
              on: {
                change: _vm.changeStart,
                changeTimezone: _vm.changeStartTimezone
              }
            }),
            _vm._v(" "),
            _c("DatePicker", {
              attrs: {
                date: _vm.endDate,
                "has-timezone": true,
                "timezone-id": _vm.endTimezone,
                prefix: "to",
                "is-all-day": _vm.isAllDay,
                "append-to-body": _vm.appendToBody,
                "user-timezone-id": _vm.userTimezone
              },
              on: {
                change: _vm.changeEnd,
                changeTimezone: _vm.changeEndTimezone
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isReadOnly
      ? _c(
          "div",
          {
            staticClass:
              "property-title-time-picker__time-pickers property-title-time-picker__time-pickers--readonly"
          },
          [
            _c(
              "div",
              { staticClass: "property-title-time-picker-read-only-wrapper" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "property-title-time-picker-read-only-wrapper__label"
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" + _vm._s(_vm.formattedStart) + "\n\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                !_vm.isAllDay
                  ? _c("div", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.startTimezone,
                          expression: "startTimezone"
                        }
                      ],
                      staticClass:
                        "property-title-time-picker-read-only-wrapper__icon icon icon-timezone",
                      class: {
                        "property-title-time-picker-read-only-wrapper__icon--highlighted":
                          _vm.highlightStartTimezone
                      }
                    })
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "property-title-time-picker-read-only-wrapper" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "property-title-time-picker-read-only-wrapper__label"
                  },
                  [_vm._v("\n\t\t\t\t" + _vm._s(_vm.formattedEnd) + "\n\t\t\t")]
                ),
                _vm._v(" "),
                !_vm.isAllDay
                  ? _c("div", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.endTimezone,
                          expression: "endTimezone"
                        }
                      ],
                      staticClass:
                        "property-title-time-picker-read-only-wrapper__icon icon icon-timezone",
                      class: {
                        "property-title-time-picker-read-only-wrapper__icon--highlighted":
                          _vm.highlightEndTimezone
                      }
                    })
                  : _vm._e()
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isReadOnly
      ? _c("div", { staticClass: "property-title-time-picker__all-day" }, [
          _c("input", {
            staticClass: "checkbox",
            attrs: {
              id: "allDay",
              type: "checkbox",
              disabled: !_vm.canModifyAllDay
            },
            domProps: { checked: _vm.isAllDay },
            on: { change: _vm.toggleAllDay }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.allDayTooltip,
                  expression: "allDayTooltip"
                }
              ],
              attrs: { for: "allDay" }
            },
            [
              _vm._v(
                "\n\t\t\t" + _vm._s(_vm.$t("calendar", "All day")) + "\n\t\t"
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }